import { cn } from "@rekati/utils";
import { MURAL, type MuralIcon } from "../../assets/mural";

/** One cut-out from iForte's mural, sitting flat on the page. Always decorative, never animated. */
export function Sticker({
  name,
  className,
  eager = false,
}: {
  name: MuralIcon;
  className?: string;
  eager?: boolean;
}) {
  return (
    <img
      src={MURAL[name]}
      alt=""
      aria-hidden="true"
      draggable={false}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={cn("pointer-events-none h-auto w-full object-contain select-none", className)}
    />
  );
}
